const mutations = {
  getAbouts: (state, about) => {
    state.about = about;
  },
  getAbout: (state, about_id) => {
    state.about_id = about_id;
  },
  postAbout: (state, new_about) => {
    state.about.push(new_about);
  },
  putAbout: (state, payload) => {
    state.about = state.about.map((about) => {
      if (about.about_id === payload.id) {
        return Object.assign({}, about, payload.aboutData);
      }
      return about;
    });
  },
  delAbout(state, id) {
    const index = state.about.findIndex(about => about.about_id == id);
    state.about.splice(index, 1);
  },
};

export default mutations;
